module.exports = __webpack_public_path__ + "img/logo_rsp.cb936d88.png";